const lengfengLogo = '/assets/app-logo.png'
const fengyinbaoLogo = '/assets/fengyinbao-logo.png'

export const products = [
  {
    key: 'lengfeng',
    name: '冷丰',
    subtitle: '社区即时零售与私域直播平台',
    kicker: '消费者端 App',
    audience: '面向社区居民',
    description: '社区好物即时到家，店长直播放心下单。',
    longDescription:
      '冷丰连接供应链、社区门店与居民消费需求，提供全品类线上购物、门店履约、店长直播带货和会员服务能力。',
    logo: lengfengLogo,
    theme: {
      brand: '#ff4b0b',
      accent: '#ff8a00',
      deep: '#8d210a'
    },
    heroScreenshots: [
      {
        image: '/assets/screenshots/app-home.jpg',
        alt: '冷丰首页直播入口截图'
      },
      {
        image: '/assets/screenshots/app-shop.jpg',
        alt: '冷丰商城分类与商品列表截图'
      }
    ],
    highlights: [
      { value: '社区', label: '附近门店匹配' },
      { value: '直播', label: '店长私域带货' },
      { value: '即时', label: '配送与自提履约' }
    ],
    screenshots: [
      {
        title: '社区首页与直播入口',
        description:
          '首页突出附近门店和直播场次，用户进入应用即可看到正在直播的社区内容，建立本地服务感和信任感。',
        image: '/assets/screenshots/app-home.jpg',
        alt: '冷丰社区首页展示附近门店与直播场次'
      },
      {
        title: '全品类社区商城',
        description:
          '商城支持搜索、分类浏览和商品列表展示，覆盖生鲜果蔬、肉禽蛋品、水产海鲜、日用百货等民生商品。',
        image: '/assets/screenshots/app-shop.jpg',
        alt: '冷丰商城展示搜索、商品分类和商品列表'
      },
      {
        title: '社区店长私域直播',
        description:
          '直播入口突出门店、开播状态和直播内容，店长可通过实时展示、互动答疑和福利活动带动下单转化。',
        image: '/assets/screenshots/app-live.jpg',
        alt: '冷丰直播间入口与直播状态展示'
      },
      {
        title: '购物车与下单引导',
        description:
          '购物车承接用户选品和批量结算流程，空状态提供清晰引导，帮助用户回到商城继续挑选商品。',
        image: '/assets/screenshots/app-cart.jpg',
        alt: '冷丰购物车空状态与继续逛逛入口'
      }
    ],
    features: [
      {
        title: '全品类商品分类',
        description: '支持多层级商品分类，覆盖生鲜、粮油、百货等社区高频消费品类。'
      },
      {
        title: '搜索与智能推荐',
        description: '支持关键词搜索、历史浏览记录和商品推荐，提升用户选品效率。'
      },
      {
        title: '购物车批量结算',
        description: '用户可将多件商品加入购物车统一结算，简化日常采购流程。'
      },
      {
        title: '附近门店匹配',
        description: '结合收货地址自动匹配社区门店，让订单进入更合适的履约节点。'
      },
      {
        title: '即时配送与自提',
        description: '支持门店拣货、打包、配送，也支持用户到店自提，兼顾效率和灵活性。'
      },
      {
        title: '私域直播带货',
        description: '店长可创建直播计划、挂载商品、发放福利，并通过互动建立社区信任。'
      },
      {
        title: '会员积分优惠券',
        description: '支持积分、优惠券领取与使用，增强用户粘性和复购率。'
      },
      {
        title: '门店管理后台',
        description: '提供订单处理、库存预警、配送任务和直播数据复盘，帮助门店提升管理效率。'
      }
    ]
  },
  {
    key: 'fengyinbao',
    name: '丰银宝',
    subtitle: '社区门店经营管理工具',
    kicker: '店铺端 App',
    audience: '面向店长与门店运营人员',
    description: '订单、商品、库存、直播和履约任务集中处理。',
    longDescription:
      '丰银宝服务社区门店的日常经营，把冷丰消费者端产生的订单、直播转化、配送自提与售后流程汇总到统一工作台，帮助门店提升响应效率。',
    logo: fengyinbaoLogo,
    theme: {
      brand: '#ff6500',
      accent: '#ff9d12',
      deep: '#8d210a'
    },
    heroScreenshots: [
      {
        image: '/assets/screenshots/fengyinbao-store-workbench.jpg',
        alt: '丰银宝门店工作台页面截图'
      },
      {
        image: '/assets/screenshots/fengyinbao-warehouse-workbench.jpg',
        alt: '丰银宝仓库工作台页面截图'
      }
    ],
    highlights: [
      { value: '核销', label: '扫码与输码核销' },
      { value: '入库', label: '采购退配调拨入库' },
      { value: '门店', label: '资料与履约配置' }
    ],
    screenshots: [
      {
        title: '门店工作台',
        description:
          '门店首页聚合扫码核销、输码核销、待核销、售后、会员码、门店订单、收货、进货和库存查询等高频入口。',
        image: '/assets/screenshots/fengyinbao-store-workbench.jpg',
        alt: '丰银宝门店工作台展示核销、售后和基础工具入口'
      },
      {
        title: '按类型查询入库',
        description:
          '按采购入库、返配入库、调拨入库分组查看待处理数量，帮助门店快速进入对应入库流程。',
        image: '/assets/screenshots/fengyinbao-inbound-types.jpg',
        alt: '丰银宝按类型查询采购入库、返配入库和调拨入库'
      },
      {
        title: '仓库履约工作台',
        description:
          '仓库角色可集中处理收货、库存查询、拣货、分拣、复核和装载发货等履约动作。',
        image: '/assets/screenshots/fengyinbao-warehouse-workbench.jpg',
        alt: '丰银宝仓库工作台展示收货、库存查询、拣货、分拣、复核和装载发货'
      },
      {
        title: '门店资料维护',
        description:
          '新增门店时可维护主体、门店名称、简称、绑定 BD、配送仓库和分类等基础经营信息。',
        image: '/assets/screenshots/fengyinbao-add-store.jpg',
        alt: '丰银宝添加门店页面展示基础信息和配送分类'
      },
      {
        title: '入库单列表',
        description:
          '入库单列表按状态筛选，展示入库单号、来源单号、货主、供应商和收货状态，方便持续追踪。',
        image: '/assets/screenshots/fengyinbao-inbound-list.jpg',
        alt: '丰银宝入库单列表展示采购入库单和收货状态'
      }
    ],
    features: [
      {
        title: '核销与售后',
        description: '支持扫码核销、输码核销、待核销处理和售后入口，覆盖门店服务闭环。'
      },
      {
        title: '门店订单',
        description: '门店订单进入统一入口，便于店员查看和处理当前门店业务任务。'
      },
      {
        title: '收货入库',
        description: '支持采购入库、返配入库和调拨入库，按类型呈现待处理数量。'
      },
      {
        title: '库存查询',
        description: '门店和仓库角色可查询库存状态，为收货、拣货和发货提供依据。'
      },
      {
        title: '拣货分拣',
        description: '仓库工作台提供拣货、分拣和复核入口，支撑标准化履约操作。'
      },
      {
        title: '装载发货',
        description: '发货前可进入装载发货流程，帮助仓库完成出库交接。'
      },
      {
        title: '门店资料维护',
        description: '支持维护门店主体、名称、简称、BD、配送仓库和分类配置。'
      },
      {
        title: '入库单追踪',
        description: '入库单列表支持按全部、初始、收货中、已关闭、已取消等状态查看。'
      }
    ]
  }
]

export function getProduct(productKey) {
  return products.find((product) => product.key === productKey)
}
